import React from 'react';
import ToolTip from '../ToolTip';

export const RadioBinary = (props) => (
	<fieldset 
		className={`radio-binary ${props.className}`}
		role="radiogroup" 
		aria-labelledby={props.name + "Label"}>
		<input 
			className='positive' 
			type="radio" 
			name={props.name} 
			id={props.posId} 
			value={props.posVal} 
			aria-checked={props.checkedVal === props.posVal}
			checked={props.checkedVal === props.posVal}
			onChange={props.handleBinaryChange} />
		<label className="binary-positive" htmlFor={props.posId}>
			<span className="accessibility-hidden">{props.posVal}</span>
			<span className="custom-radio"></span>
		</label>

		<input 
			className="negative" 
			type="radio"
			name={props.name} 
			id={props.negId} 
			value={props.negVal} 
			aria-checked={props.checkedVal === props.negVal}
			checked={props.checkedVal === props.negVal}
			onChange={props.handleBinaryChange} />
		<label className="binary-negative" htmlFor={props.negId}>
			<span className="accessibility-hidden">{props.negVal}</span>
			<span className="custom-radio"></span>
		</label>
		<legend id={props.name + "Label"}>
			{props.legend}
			{props.info ? (
                <ToolTip
	                title={props.title} 
                	info={props.info} />
            ) : ( false )}
		</legend>
		<span className="form-error">
    		<p>{props.errMessage}</p>
    	</span>
	</fieldset>
);


// WEBPACK FOOTER //
// ./src/components/RadioBinary/RadioBinary.js